exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-access-container {\n  margin-top: 35px; }\n\n.containerBorder {\n  border-top: 1px solid #ccc;\n  border-bottom: 1px solid #ccc; }\n\n.button-container {\n  margin: 20px 0 30px 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/training-management/super-admin-access/super-admin-access.component.scss
// module id = ../../../../../src/app/core/components/training-management/super-admin-access/super-admin-access.component.scss
// module chunks = main